import React from "react";

function QuickCreate({ color }) {
  return (

      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M22.5 21C22.5 21.825 21.828 22.5 21 22.5H3C2.172 22.5 1.5 21.825 1.5 21V3C1.5 2.175 2.172 1.5 3 1.5H21C21.828 1.5 22.5 2.175 22.5 3V21ZM21 0H3C1.34325 0 0 1.3425 0 3V21C0 22.6575 1.34325 24 3 24H21C22.6567 24 24 22.6575 24 21V3C24 1.3425 22.6567 0 21 0ZM16.5 11.25H12.75V7.5C12.75 7.0875 12.414 6.75 12 6.75C11.586 6.75 11.25 7.0875 11.25 7.5V11.25H7.5C7.086 11.25 6.75 11.5875 6.75 12C6.75 12.4125 7.086 12.75 7.5 12.75H11.25V16.5C11.25 16.9125 11.586 17.25 12 17.25C12.414 17.25 12.75 16.9125 12.75 16.5V12.75H16.5C16.914 12.75 17.25 12.4125 17.25 12C17.25 11.5875 16.914 11.25 16.5 11.25Z"
          fill="white"
        />
      </svg>
  );
}

export default QuickCreate;
